/**
 * sidebarPromo.js
 */

// Import
import './sidebarPromo.scss';
import $ from 'jquery';

$(document).ready(function() {

});
